export { GET, DELETE, POST, PATCH } from './services/owsRestApi';
